import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {DatepickerModule} from 'ng2-bootstrap/datepicker';
import {DropdownModule} from 'ng2-bootstrap/dropdown';
import {TimepickerModule} from 'ng2-bootstrap/timepicker';
import {TooltipModule} from 'ng2-bootstrap/tooltip';

import {ContentDatepickerComponent} from './content-datepicker.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    DropdownModule.forRoot(),
    TooltipModule.forRoot(),
  ],
  declarations: [
    ContentDatepickerComponent,
  ],
  exports: [
    ContentDatepickerComponent,
  ],
})
export class ContentDatepickerModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/contents/contents-details/content-datepicker/content-datepicker.module.ts